import React from 'react';
import { motion } from 'framer-motion';
import { GaugeIcon, SplitIcon, DropletsIcon, AlertTriangleIcon } from 'lucide-react';
const CAUSES = [{
  icon: SplitIcon,
  title: 'Broken or misaligned heads',
  desc: 'Sprinkler heads wasting water in the wrong direction — spraying the sidewalk instead of your grass.'
}, {
  icon: GaugeIcon,
  title: 'Pressure imbalances',
  desc: 'Some zones flood while others run dry, leaving patchy, inconsistent coverage across your lawn.'
}, {
  icon: DropletsIcon,
  title: 'Underground leaks',
  desc: 'Silent leaks adding $80–$200 to your monthly water bill — invisible from the surface.'
}];
export function ProblemSection() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-231" data-mp="3egz72b6aodil">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-232" data-mp="3ehidauml1dgs">
        <div className="mx-auto max-w-3xl text-center" data-id="element-233" data-mp="1p1iz2z43wxua">
          <span className="inline-flex items-center gap-2 rounded-full bg-red-50 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-red-600" data-id="element-234" data-mp="1p4552ubcn5ae">
            <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-235" data-mp="jdwmj2snhwz0" />
            The Real Problem
          </span>
          <h2 className="mt-5 font-display text-3xl font-extrabold text-slate-900 sm:text-4xl" data-id="element-236" data-mp="obetwor0s44w">
            The real problem is never what you think it is
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-237" data-mp="x4i9b2l86r26">
            When your lawn looks patchy, most people assume it's not getting enough
            water. The real cause is almost always one of three things — and none of
            them are visible from the surface.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-238" data-mp="1c1soon0zoh36">
          {CAUSES.map((cause, i) => <motion.div key={cause.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-slate-200 bg-slate-50 p-7" data-id="element-239" data-mp="1bzy6vhl0l53b" data-mpi={i}>
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-nfblue/10 text-nfblue" data-id="element-240" data-mp="p0it7l7dtrne">
                <cause.icon className="h-6 w-6" data-id="element-241" data-mp="k3aa9ieetjl3" />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold text-slate-900" data-id="element-242" data-mp="y1qcox58onxf">
                {cause.title}
              </h3>
              <p className="mt-2 text-slate-600" data-id="element-243" data-mp="u1ga7ugnofnb">{cause.desc}</p>
            </motion.div>)}
        </div>

        <div className="mt-10 rounded-2xl border-l-4 border-nfblue bg-nfblue/5 p-6 sm:p-8" data-id="element-244" data-mp="17ws2zwb93w1l">
          <p className="text-lg leading-relaxed text-slate-700" data-id="element-245" data-mp="12xxkywl3ybij">
            In Texas, irrigation work above a certain scope legally requires a{' '}
            <strong className="text-slate-900" data-id="element-246" data-mp="1cpl84lamt6e7">licensed irrigator</strong>. That
            license exists because improper irrigation can contaminate your water
            supply, destroy your foundation, and create legal liability on your
            property. Yet every day, thousands of Texas homeowners hand that job to an
            unlicensed handyman with a truck and a YouTube education.
          </p>
        </div>
      </div>
    </section>;
}